export default "__VITE_ASSET__JpGVG_fX__"